import { Form, Button, Card, CardBody, Alert} from 'react-bootstrap'
import { grey, accentColor, loginBGImage, cdfontFamily, cdtextcolor, navbarcolor, navbartextcolor, pagesbgcolor, black, white} from '../../config/Colors';

const LoginOutDiv = { 
    display: "flex",
    width: "100%",
    height: "100vh",
    minHeight: "100vh",
    minWidth: "100vh",
    backgroundImage: `url(${process.env.PUBLIC_URL + loginBGImage})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center"
};
const NavDiv = { 
    display: "flex",
    width: "100%",
    height: "10%",
    minHeight: "10%",
    minWidth: "100vh",
    color:navbartextcolor,
    //backgroundColor:navbarcolor,
    backgroundImage: `url(${process.env.PUBLIC_URL + loginBGImage})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top"
};
const Container = { 
    display: "flex",
    justifyContent: "start",
    flexDirection: "column",
    alignItems: "flex-end",
    fontFamily: cdfontFamily,
};
const DataEntryContainer = { 
    display: "flex",
    padding: "20px 20px", 
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "flex-end",
    fontFamily: cdfontFamily,
};
const NavInsideDiv = { 
    width:"30%",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: cdfontFamily,
};
const NavContainer = { 
    display: "flex",
    width: "100%",
    minWidth: "100vh",
    justifyContent: "space-between",
    fontFamily: cdfontFamily,
    padding: "20px 20px", 
    textAlign: "center", 
};
const NavCenter = { 
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: cdfontFamily,
};
const NavRight = { 
    display: "flex",
    justifyContent: "right",
    alignItems: "right",
    fontFamily: cdfontFamily,
};
const Header = { 
    padding: "10px 20px", 
    textAlign: "center", 
    color: cdtextcolor,
    fontFamily: cdfontFamily,
    fontWeight: "400",
};
const SubHeader = { 
    //padding: "10px 20px", 
    textAlign: "left", 
    color: grey,
    fontFamily: cdfontFamily,
    fontWeight: "400",
};
const ProductNameHeader = { 
    padding: "10px 20px", 
    textAlign: "center", 
    color: navbartextcolor,
    fontFamily: cdfontFamily,
    fontWeight: "400",
};
const NavHeader = { 
    padding: "10px 20px", 
    textAlign: "center", 
    color: navbartextcolor,
    fontFamily: cdfontFamily,
    fontWeight: "300",
};
const LabelContainer = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};
const Label = { 
    padding: "10px 20px", 
    textAlign: "center", 
    color:cdtextcolor, 
    fontFamily: cdfontFamily,
    fontWeight: "400",
};
const LabelNoPadding = { 
    //padding: "10px 20px", 
    textAlign: "center", 
    color:cdtextcolor, 
    fontFamily: cdfontFamily,
    fontWeight: "400",
};
const Link = { 
    padding: "5px 10px", 
    textAlign: "center", 
    color:cdtextcolor, 
    fontFamily: cdfontFamily,
    fontWeight: "400",
};
const MenuLink = { 
    padding: "5px 10px", 
    textAlign: "center", 
    color:navbartextcolor, 
    fontFamily: cdfontFamily,
    fontWeight: "400",
};
const LinkBold = { 
    //padding: "5px 10px", 
    textAlign: "center", 
    color:cdtextcolor, 
    fontFamily: cdfontFamily,
    fontWeight: "400",
};
const SubLink = { 
    //padding: "5px 10px", 
    textAlign: "center", 
    color:grey, 
    fontFamily: cdfontFamily,
    fontWeight: "300",
};
const CDButton = {
    alignItems: "center", 
    width:'30%',
    backgroundColor:accentColor,
    fontFamily: cdfontFamily,
    fontWeight: "400",    
}
const CDButton20 = {
    alignItems: "center", 
    width:'20%',
    backgroundColor:accentColor,
    fontFamily: cdfontFamily,
    fontWeight: "400",    
}
const CDButton50 = {
    alignItems: "center", 
    width:'50%',
    backgroundColor:accentColor,
    fontFamily: cdfontFamily,
    fontWeight: "400",    
}
const CDButtonDisabled50 = {
    alignItems: "center", 
    width:'50%',
    backgroundColor:grey,
    fontFamily: cdfontFamily,
    fontWeight: "400",    
    cursor: 'not-allowed',
}
const CDFullButton = {
    alignItems: "center", 
    width:'100%',
    backgroundColor:accentColor,
    fontFamily: cdfontFamily,
    fontWeight: "400",    
}
const CDPillFullButton = {
    alignItems: "center", 
    width:'85%',
    height:"50%",
    minHeight:"5px",
    backgroundColor:accentColor,
    fontFamily: cdfontFamily,
    fontWeight: "300",
    borderRadius:'30px',    
}
const ProfileIconButton = {
    padding: "5px 10px", 
    alignItems: "center", 
    backgroundColor:accentColor,
    fontFamily: cdfontFamily,
    fontWeight: "600", 
    borderRadius: "50%",
    width: "50px",
    height: "50px",
    textAlign: "center",           
}
const FormContainer = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};
const ErrorMessage = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};
const DashboardContainer = { 
    padding: "10px 10px", 
    backgroundColor:pagesbgcolor,
    //display: "flex",
    width: "80%",
    height: "90vh",
    minHeight: "90vh",
    minWidth: "80vh",
    margin:"auto",
    //flexDirection:"row",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: cdfontFamily,
    // borderStyle: 'solid',
    // borderWidth: 'medium',
};
const MainBGDiv = {
    backgroundColor:pagesbgcolor,
    textAlign:"center",  
    width: "100%",
    height: "100vh",
    minHeight: "100vh",
    minWidth: "100vh",      
}
const MainBGDivNoAlign = {
    backgroundColor:pagesbgcolor,
    width: "100%",
    height: "100vh",
    minHeight: "100vh",
    minWidth: "100vh",      
}
const Image25 = {
    width: "25px",
    height: "25px",
}
const Image60Border = {
    width: "60px",
    height: "60px",
    //overflow: "hidden",
    borderWidth: '3',
    borderColor: accentColor,
    borderRadius: '8',
}
const Image100 = {
    width: "100px",
    height: "100px",
}
const td33 = {
    textAlign:'left',
    width: "33%",
}
const td34 = {
    textAlign:'left',
    width: "34%",
}
const tableText = {
    color:grey,
    textAlign:'center',
}

export const styles = {
    LoginOutDiv: LoginOutDiv,
    NavDiv: NavDiv,
    NavInsideDiv:NavInsideDiv,
    Container: Container,
    NavContainer: NavContainer,
    NavCenter: NavCenter,
    NavRight: NavRight,
    Header: Header,
    SubHeader: SubHeader,
    NavHeader:NavHeader,
    LabelContainer: LabelContainer,
    Label: Label,
    LabelNoPadding:LabelNoPadding,
    ErrorMessage: ErrorMessage,
    FormContainer: FormContainer,
    Link: Link,
    MenuLink: MenuLink,
    LinkBold: LinkBold,
    SubLink: SubLink,
    CDButton: CDButton,
    CDButton20: CDButton20,
    CDButton50: CDButton50,
    CDButtonDisabled50: CDButtonDisabled50,
    CDFullButton: CDFullButton,
    CDPillFullButton:CDPillFullButton,
    ProfileIconButton: ProfileIconButton,
    ProductNameHeader: ProductNameHeader,
    DashboardContainer: DashboardContainer,
    MainBGDiv: MainBGDiv,
    MainBGDivNoAlign:MainBGDivNoAlign,
    DataEntryContainer:DataEntryContainer,
    Image25:Image25,
    Image60Border:Image60Border,
    Image100:Image100,
    td33:td33,
    td34:td34,
    tableText:tableText,
}
